// Функция для проверки попадания значения GSM в заданный диапазон
function isGSMInRange(value, gsm) {
  switch (value) {
    case 1:
      return gsm <= 0 && gsm >= -60;
    case 2:
      return gsm < -60 && gsm >= -70;
    case 3:
      return gsm < -70 && gsm >= -80;
    case 4:
      return gsm < -80 && gsm >= -90;
    case 5:
      return gsm < -90;
    default:
      return false;
  }
}

// Приводим ключи фильтра к формату, который лежит в событиях
const normalizeKey = (key) => {
  if (key === 'btnAlert') return 'btn_alert';
  if (key === 'btnClear') return 'btn_clear';
  return key;
};

export function filterSignals(signals, filterCriteria) {
  const signalsFiltered = signals?.filter((item) => {
    return Object.keys(filterCriteria).every((key) => {
      const normalizedKey = normalizeKey(key);
      const value = filterCriteria[key];
      const itemValue = item[normalizedKey];

      // Пустые значения — фильтр не применяется
      if (value === '' || value === null || value === undefined) {
        return true;
      }

      //проверка для поля distance
      if (normalizedKey === 'distance') {
        return Number(itemValue) <= Number(value);
      }
      //проверка для поля preciseDistance
      if (normalizedKey === 'preciseDistance') {
        return Number(itemValue) <= Number(value);
      }

      //проверка для поля safeZoneWidth (ширина БЗ)
      if (normalizedKey === 'safeZoneWidth') {
        return Number(itemValue) >= Number(value);
      }
      // Проверка для полей iurGPS kuobzGPS
      if (normalizedKey === 'iurGPS' || normalizedKey === 'kuobzGPS') {
        return Number(itemValue) >= Number(value);
      }

      // Проверка для полей iurGSM и kuobzGSM
      if (normalizedKey === 'iurGSM' || normalizedKey === 'kuobzGSM') {
        // Преобразуем item[key] к числу для сравнения
        const gsmValue = Number(itemValue);
        return isGSMInRange(value, gsmValue);
      }

      // Особая обработка для полей btn_alert, btn_clear, fencingBtnServer
      if (
        (normalizedKey === 'btn_alert' || normalizedKey === 'btn_clear' || normalizedKey === 'fencingBtnServer') &&
        value === true
      ) {
        return Boolean(itemValue) === value;
      }

      // Проверка для поля transferRails
      if (normalizedKey === 'transferRails') {
        if (value === true) {
          // Возвращает true, если transferRails существует и не является пустой строкой
          return itemValue !== undefined && itemValue !== '';
        }
        // value === false — фильтр не применяется
        return true;
      }

      // Для поля 'index' преобразуем значения к числу перед сравнением, если они не пустые
      if (normalizedKey === 'index') {
        return Number(itemValue) === Number(value);
      }

      // Пропускаем фильтрацию по полю, если значение в критериях пустая строка
      return itemValue === value;
    });
  });
  return signalsFiltered;
}
